export const meta = {
  title: 'Unit Conversion',
  description:
    'Free, online, simple to use, quick unit converter for most common units of measurement. Easily copy the result to your clipboard in order to use anywhere you want.',
  image: '%PUBLIC_URL%/android-icon-192x192.png',
  url: 'https://unitconversion.page/',
  type: 'website',
}
